(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ChartExportFileController', ChartExportFileController);

    ChartExportFileController.$inject = ['$scope', '$state', 'ChartExportFile', 'entity'];

    function ChartExportFileController($scope, $state, ChartExportFile, entity) {
        var vm = this;

        vm.entity = entity;

        var params = {
            sort: 'id,desc',
            size: 10,
            chartExportId: entity.id
        };

        vm.descriptor = {
            title: 'Chart Export Files - ' + entity.id,
            newButtonTitle: 'New Export',
            entityClassHumanized: 'Chart Export',
            entityStateName: 'chart-export',
            service: ChartExportFile,
            serviceMethod: 'query',
            params: params,
            newAction: false,
            pagination: 'remote',
            enableSearch: false,
            columns: [
                {
                    name: 'id',
                    title: 'ID'
                },
                // {
                //     name: 'name',
                //     title: 'Name',
                // },
                {
                    name: 'chartId',
                    title: 'Chart ID',
                    render: function (entity) {
                        return entity.chart.id;
                    }
                },
                {
                    name: 'firstName',
                    title: 'First Name',
                    render: function (entity) {
                        return entity.chart.firstName;
                    }
                },
                {
                    name: 'lastName',
                    title: 'Last Name',
                    render: function (entity) {
                        return entity.chart.lastName;
                    }
                },
                {
                    name: 'mrNo',
                    title: 'mrNo',
                    render: function (entity) {
                        return entity.chart.mrNo;
                    }
                },
                {
                    name: 'status',
                    title: 'Status',
                },
                {
                    name: 'fileSize',
                    title: 'File Size',
                },
                {
                    name: 'file',
                    title: 'file',
                },
                // {
                //     name: 'charts',
                //     title: 'Charts',
                // },
                // {
                //     name: 'progress',
                //     title: 'Progress',
                // },
                // {
                //     name: 'fails',
                //     title: 'Fails',
                // },

                // {
                //     name: 'facesheetTpl.id',
                //     title: 'Facesheet ID',
                //     render: function (entity) {
                //         return entity.facesheetTpl.id;
                //     }
                // },
                // {
                //     name: 'facesheetTpl.name',
                //     title: 'Facesheet',
                //     render: function (entity) {
                //         return entity.facesheetTpl.name;
                //     }
                // }
            ],
            filters: [
                {
                    name: 'status',
                    placeholder: 'Status...',
                    type: 'select',
                    values: ['COMPLETED', 'FAILED'],
                    getValue: function (entity) {
                        return entity;
                    },
                    getDisplayValue: function (entity) {
                        return entity;
                    },
                    visible: true
                },
            ]
        }
    }
})();
